import { sleep } from "../lib/utils.js";

class FFCartAccordion extends HTMLElement {

  entries: NodeListOf<HTMLElement>

	constructor(){
		super()
		this.entries = this.querySelectorAll('.ff-accordion-header');
    this.init()
	}

	init(){
    this.entries.forEach(el => {
      el.addEventListener( 'click', this.toggle.bind(this) );
      const parent = el.parentNode;
      if( parent instanceof HTMLElement && parent.classList.contains("ff-active")){
        this.open( parent );
      }
    })
	}

	toggle(e: MouseEvent){
		e.preventDefault();
    if( !(e.target instanceof HTMLElement) ) return
		const entry = e.target?.parentNode;
    if( !(entry instanceof HTMLElement) ) return
		
		if( entry?.classList.contains( 'ff-active' ) ){
			this.close( entry );
		}else{
			this.open( entry );
		}
	}

	async close( entry: HTMLElement ){
		const wrapper = entry.querySelector( '.ff-wrap-accordion-content' );
    if( !(wrapper instanceof HTMLElement) ) return
		const content = wrapper.querySelector( '.ff-accordion-content' );
    if( !content ) return
		const h = content.clientHeight;
		entry.classList.remove( 'ff-active' );
		wrapper.style.height = h + 'px';
    await sleep(10)
    wrapper.removeAttribute('style');
	}

	async open( entry: HTMLElement ){
		const wrapper = entry.querySelector( '.ff-wrap-accordion-content' );
    if( !(wrapper instanceof HTMLElement) ) return
		const content = wrapper.querySelector( '.ff-accordion-content' );
    if( !content ) return
		const h = content.clientHeight;

		entry.classList.add( 'ff-active' );
		wrapper.style.height = h + 'px';
		wrapper.style.opacity = "1";
    await sleep(500)
    wrapper.style.height = 'auto';
	}
}
customElements.define('ff-cart-accordion', FFCartAccordion);